/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StorageObjectDto } from '../../models/storage-object-dto';

export interface GetStorageObject$Params {
  id: string;
}

export function getStorageObject(http: HttpClient, rootUrl: string, params: GetStorageObject$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDto>> {
  const rb = new RequestBuilder(rootUrl, getStorageObject.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StorageObjectDto>;
    })
  );
}

getStorageObject.PATH = '/v0/storageObjects/{id}';
